<template>
  <v-content>
    <div id="core-view">

        <loading
          :active="this.$store.state.app.fetching"
          :can-cancel="false"
          :is-full-page="true"
          color="#4caf50"/>

          <transition name="fade">
            <router-view  v-show="!this.$store.state.app.fetching"/>
          </transition>
    </div>
    <core-footer v-show="!this.$store.state.app.fetching"/>
  </v-content>
</template>

<script>
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  metaInfo () {
    return {
      title: 'E-Reciklaža'
    }
  }
}
</script>

<style>
  .fade-enter-active{
    transition: opacity 1s
  }

  .fade-leave-active {
    opacity: 0;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0
  }

  #core-view {
    padding-bottom: 100px;
  }
</style>
